module.exports = __webpack_public_path__ + "static/media/appointments-list-icon.4e1f058f.svg";